import {
    REQUEST_UPDATE_CUSTOMER,
    REQUEST_UPDATE_CUSTOMER_FAILURE,
    REQUEST_UPDATE_CUSTOMER_SUCCESS
} from "../../../constant/master/TransCustomerConstant";


const initialState = {
    updateCustomer: {
        data: [],
        status: 'idle',
        isLoading: true,
    },
};


export const updateCustomerReducer = (state = initialState, action) => {
    const {type, payload} = action;
    switch (type) {
        case REQUEST_UPDATE_CUSTOMER:
            return {
                ...state,
                updateCustomer: {
                    data: [],
                    status: 'fetching',
                    isLoading: true,
                },
            };
        case REQUEST_UPDATE_CUSTOMER_SUCCESS:
            return {
                ...state,
                updateCustomer: {
                    data: payload,
                    status: 'ready',
                    isLoading: false,
                },
            };
        case REQUEST_UPDATE_CUSTOMER_FAILURE:
            return {
                ...state,
                updateCustomer: {
                    data: [],
                    status: 'fetching',
                },
            };
        default:
            return state;
    }
}
